import React from "react";
import { blue60 } from "../../vars";

const Ruble = ({ width = 24, height = 24, color = blue60, className, strokeWidth }) => {
    return (
        <svg width={width} height={height} viewBox="0 1.5 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '-3px'}}>
            {/* style={`fill: none; stroke: ${color}; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;`} */}
            <path id="primary" d="M14,11H9V3h5a4,4,0,0,1,4,4h0A4,4,0,0,1,14,11ZM9,3V21M6,11H9" stroke={color} stroke-width={strokeWidth} ></path>
            {/* style={`fill: none; stroke: ${color}; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;`} */}
            <line id="primary-2" data-name="primary" x1="6" y1="15" x2="15" y2="15" stroke={color}></line>
        </svg>
    );
};

export default Ruble